/**
 * User roles, mirroring the backend's src/services/shared/roles.js.
 *
 * "Field roles" share the promoter portal (check-in, sales, display proof).
 * A merchandiser differs only at check-in, where they record a merchandising
 * (MM) task instead of the roadshow flag.
 *
 * Note the terminology split: "merchandiser" is the person/role, while
 * "merchandising" describes the work itself (hence MM task types).
 */
export const ROLES = Object.freeze({
  PROMOTER: "promoter",
  MERCHANDISER: "merchandiser",
  ADMIN: "admin",
  SUPER_ADMIN: "super_admin",
});

export const FIELD_ROLES = Object.freeze([ROLES.PROMOTER, ROLES.MERCHANDISER]);

export const normalizeRole = (value) => {
  if (value === undefined || value === null) return null;
  const normalized = String(value).trim().toLowerCase().replace(/[-\s]+/g, "_");
  return normalized || null;
};

export const isFieldRole = (value) => FIELD_ROLES.includes(normalizeRole(value));

export const isMerchandiser = (value) =>
  normalizeRole(value) === ROLES.MERCHANDISER;

export const isAdminRole = (value) =>
  [ROLES.ADMIN, ROLES.SUPER_ADMIN].includes(normalizeRole(value));

/** i18n key for a role label, e.g. roles.merchandiser */
export const roleLabelKey = (value) => `roles.${normalizeRole(value) || "unknown"}`;

/** Portal a signed-in user lands on; null when the role has no portal. */
export const homeRouteForRole = (value) => {
  if (isAdminRole(value)) return "/admin";
  if (isFieldRole(value)) return "/promoter";
  return null;
};
